import "./styles.scss";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";

export default function MainLayout() {
  return (
    <div className="main-layout">
      <Header />
      <Sidebar />
      <main>
        <div className="wrapper">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
